import { Component } from '@angular/core';
import { PanelScrollingService } from '../../services/panel-scrolling.service';

/**
 *
 * */
@Component({
  selector: 'campfire-panel-selector',
  templateUrl: './panel-selector.component.html',
  styleUrls: ['./panel-selector.component.scss']
})
export class PanelSelectorComponent {
  constructor(private panelScrolling: PanelScrollingService) {

  }

  moveTo(pageName: string): void {
    this.panelScrolling.moveToPage(pageName);
  }
}
